module.exports = __webpack_public_path__ + "static/media/icon_angle-right.dc28ae39.svg";